import { datadogLogs } from '@datadog/browser-logs';
const log = (level, message, context) => {
    const payload = context !== null && context !== void 0 ? context : undefined;
    if (payload) {
        datadogLogs.logger[level](message, payload);
    }
    else {
        datadogLogs.logger[level](message);
    }
};
export const logger = {
    debug(message, context) {
        log('debug', message, context);
    },
    info(message, context) {
        log('info', message, context);
    },
    warn(message, context) {
        log('warn', message, context);
    },
    error(message, context) {
        log('error', message, context);
    }
};
